module.exports = __webpack_public_path__ + "media/images/career_camp/2022/career_pass_hands-2ec802177465e387a53734db920263c1.svg";